<template>
    <div class="customer">
        <div class="title" @click="gotoSela">
            生活方式
        </div>
        <div v-if="pc" class="content1">
            <div v-for="(item,index) in list" :key="index" @click="gotoInfo(item.id)">
                <img :src="`http://www.zrichhome.com/${item.picurl}`" alt="">
                <div class="nr">
                    <p>{{item.title}}</p>
                </div>
                <em></em>
            </div>
        </div>
        <div v-else class="content2">
            <swiper class="swiper" :options="swiperOption2" ref="mySwipers2">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div @click="gotoInfo(item.id)">
                        <img :src="`http://www.zrichhome.com/${item.picurl}`" alt="">
                        <div class="nr">
                            <p>{{item.title}}</p>
                        </div>
                        <em></em>
                    </div>
                </swiper-slide>
            </swiper>
            <!--            <div @click="gotoInfo(info.id)">-->
            <!--                <img :src="`http://www.zrichhome.com/${info.picurl}`" alt="">-->
            <!--                <div class="nr">-->
            <!--                    <p>{{info.title}}</p>-->
            <!--                </div>-->
            <!--                <em></em>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
    import {getProductsUrl} from '../util/lang'
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";

    export default {
        name: "customer",
        data() {
            return {
                list: [],
                // info: {},
                pc: true,
                swiperOption2: {
                    notNextTick: true,
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    init: false,
                    loop: true,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 2000
                    },
                }
            }
        },
        components: {
            swiper, swiperSlide
        },
        mounted() {
            this.$nextTick(() => {
                var offsetWid = document.documentElement.clientWidth
                if (offsetWid <= 1000) {
                    this.pc = false
                }
            })
            setTimeout(() => {
                this.getProList('22')
            }, 100)
        },
        methods: {
            gotoSela() {
                const link = `/sale.html`
                window.open(link, '_blank')
            },
            gotoInfo(id) {
                const link = `/lifeInfo.html?id=${id}`
                window.open(link, '_blank')
            },
            getProList(id) {
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    res.data.data.map((item) => {
                        if (item.flag == "c") {
                            this.list.push(item)
                        }
                    })
                    // this.info = this.list[0]
                    if(!this.pc){
                        setTimeout(() => {
                            this.$refs.mySwipers2.swiper.init()
                        }, 100)
                    }

                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .customer {
        width: 100%;
        animation: 2s polygon forwards linear;

        .title {
            width: 140px;
            height: 130px;
            background: rgba(51, 49, 55, 1);
            text-align: center;
            line-height: 130px;
            color: white;
            margin: 0 auto;
            font-family: "SourceHanSerifCN-Medium";
            cursor: pointer;
        }

        .content1 {
            width: 100%;
            display: flex;
            flex-direction: row;
            margin: 60px auto;

            div {
                width: 25%;
                cursor: pointer;
                overflow: hidden;
                position: relative;

                em {
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.4);
                    position: absolute;
                    left: 0;
                    top: 0;
                }

                img {
                    width: 100%;
                    display: block;
                    transition: all 600ms;
                    object-fit: cover;
                }

                .nr {
                    position: absolute;
                    left: 0;
                    top: 0;
                    transition: all 600ms;
                    width: 100%;
                    height: 100%;
                    background-color: #333137;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    opacity: 0;
                    align-items: center;

                    p {
                        color: white;
                        font-size: 14px;
                        font-family: "nm";
                        transition: all 600ms;
                    }
                }

                &:hover {
                    img {
                        opacity: 0;
                    }

                    .nr {
                        opacity: 1;
                    }
                }
            }
        }

        .content2 {
            width: 100%;
            display: none;
            flex-direction: row;
            margin: 60px auto;

            .swiper {
                .item {
                    div {
                        width: 100%;
                        cursor: pointer;
                        overflow: hidden;
                        position: relative;

                        em {
                            display: block;
                            width: 100%;
                            height: 100%;
                            background: rgba(0, 0, 0, 0.4);
                            position: absolute;
                            left: 0;
                            top: 0;
                        }

                        img {
                            width: 100%;
                            display: block;
                            transition: all 600ms;
                            object-fit: cover;
                        }

                        .nr {
                            position: absolute;
                            left: 0;
                            top: 0;
                            transition: all 600ms;
                            width: 100%;
                            height: 100%;
                            background-color: #333137;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            opacity: 0;
                            align-items: center;

                            p {
                                color: white;
                                font-size: 14px;
                                font-family: "nm";
                                transition: all 600ms;
                            }
                        }

                        &:hover {
                            img {
                                opacity: 0;
                            }

                            .nr {
                                opacity: 1;
                            }
                        }
                    }
                }
            }

        }

        @keyframes polygon {
            0% {
                clip-path: polygon(0 0, 0 100%, 0 100%, 0 0);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 0);
                opacity: 1;
            }
        }

        @media screen and (max-width: 1000px) {
            .title {
                width: 100px;
                height: 90px;
                line-height: 90px;
            }
            .content1{
                display: none;
            }
            .content2 {
                display: flex;
                flex-wrap: wrap;

                div {
                    width: 100%;
                    margin-top: 10px;

                    &:hover {
                        .nr {
                            margin-top: 0;
                        }
                    }
                }
            }
        }

    }
</style>
